<!--
Author: TangChen
Date: 2018-11-07
Desc: 投资者资料上传，由index.js 配置引入
-->
<template>
    <div>
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div :class="'bizcomp-investor-data-up bizcomp ' + className">
            <el-row>
                <div class="title">投资者转换资料上传</div>
            </el-row>
            <el-row v-if="!hadUpload" class="investor-data-up">
                <el-alert
                    title="上传的图片，每张不得超过1M;仅支持jpg、jpeg格式。"
                    type="warning"
                    show-icon
                    :closable="false"
                />
                <img-upload v-if="!isIE9" :flag="$route.query.flag || '0'" v-on:success="imgUp" />
                <div v-else class="cant-up">
                    <div class="cant-info">
                        为保证上传证件质量，暂不支持IE9浏览器上传认证证件照及资料文档，推荐使用谷歌、火狐或ie10以上浏览器进行上传认证。
                    </div>
                    <el-button class="medium" v-on:click="$router.back()">确定</el-button>
                </div>
                <!-- <data-up v-else :flag="$route.query.flag || '0'" v-on:success="imgUp" /> -->
            </el-row>
            <result
                v-if="hadUpload"
                :result="resultObj"
                v-on:login-now="$router.push({ name: 'home' })"
                v-on:return-login="$router.push({ name: 'acctManager' })"
            />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
import imgUpload from "@/components/form/imgUploadDc.vue";
import userApi from "@/api/user";

export default {
    name: "InvestorDataUp",
    components: {
        result,
        imgUpload
    },
    mixins: [mixin],
    data() {
        return {
            isIE9: false,
            hadUpload: false,
            resultObj: {
                // 结果页面信息
                cla: "register-success",
                msg: "转换资料提交成功！",
                btnMsg: "您的投资者类型转换申请提交成功，请耐心等待审核结果",
                btnL: {
                    text: "返回首页",
                    event: "login-now"
                },
                btnR: {
                    text: "进入信息中心",
                    event: "return-login"
                }
            }
        };
    },
    created() {
        if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
            this.isIE9 = true;
        }
    },
    methods: {
        // 文件上传成功，发起普通转专业请求
        imgUp(list) {
            this.toProfessional(list);
        },
        // 转换为专业投资者
        async toProfessional(list) {
            let params = this.$store.state.user.changeParams;
            params.sysFileattachments = list;
            const res = await userApi.ordinary2Professional(params);
            if (res.data) {
                this.hadUpload = true;
            }
        }
    }
};
</script>
<style lang="scss">
/*用户信息 */
.bizcomp-investor-data-up {
    .title {
        padding: 16px 20px 0;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
    }
    .investor-data-up {
        padding: 16px 0 0;
        .comp-result {
            padding-bottom: 50px;
        }
    }
    .cant-info {
        text-align: center;
        font-size: 18px;
        color: #333333;
        line-height: 30px;
        margin: 20px auto;
    }
    .cant-up {
        margin: 30px auto;
        width: 100%;
        text-align: center;
    }
}
</style>
